// Collection wishlist, Icon wishlist not show
document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

var html = document.documentElement;
var isMacLike = !!navigator.platform && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
if (isMacLike) {
    html.classList.add('isMac');
}

// Check with brower safari
if (navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1) {
    html.classList.add("isSafari");
}


$(document).ready(function () {
    // Footer
    $('.item_menu__list .footer-block__heading').on("click", function () {
        $(this).parent().toggleClass("active");
    })

    // Mega menu mobile
    $('.js-header-sub-t-a').removeAttr("href");

    $('.header-navs li.primary-nav__item').hover(
        function () {
            $(this).addClass("active-mega");
            $(this).parents(".header-navs").addClass("active-overlay-mega"); 
        },
        function () {
            $(this).removeClass("active-mega");
            $(this).parents(".header-navs").removeClass("active-overlay-mega"); 
        }
    )

});

// Home
$('.section-feature-collection .product-grid').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 3,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
        }
    },
    {
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            infinite: true,
            dots: true
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            infinite: true,
            dots: true
        }
    }
    ]
});

// Home slider banner
$('.slider-custom .slider-item').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [{
        breakpoint: 980,
        settings: {
            arrows: false,
            dots: true
        }
    }]
});

// Video slider
$('.slidershow-hero_video .slideshow').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [{
        breakpoint: 980,
        settings: {
            arrows: false,
            dots: true
        }
    }]
});

// Header transparent or solid
$('.template-index .transparent-header').parents("body").addClass("transparent-header")

// Back to top
$(".back-to-top").click(function () {
    $("html, body").animate({
        scrollTop: 0
    }, 1000);
});

// Collection filter category
$('.category-filter-collection .facets__title').on('click', function (event) {
    $(this).parent('.category-filter-collection').toggleClass('active');
});

// remove class when click outside
$(document).on('click', function (event) {
    if (!$(event.target).closest('.category-filter-collection').length) {
        $(".category-filter-collection").removeClass("active");
    }
})

if ($('.facets__list__category').length) {
    var url = window.location.href;
    $(".facets__list__category > li > a").each(function () {
        var urla = $(this).attr("href");
        if (url == urla) {
            $(this).addClass("active-link");
        }
    });
}


// Menu tab filter category
$('.category-tab-collection .mobile-facets__submenu').on('click', function () {
    $(this).parents('.category-tab-collection').removeClass('menu-opening');
});

$('.category-tab-collection .mobile-facets__summary_category span').on('click', function () {
    $(this).parents('.category-tab-collection').addClass('menu-opening');
});

// PDP
$(document).ready(function () {

    $(".product_tabs .item h3").on("click", function () {
        $(this).parent(".item").toggleClass("active");
    })

    // $('.faq_wrapper_content .item_faqs h3').on("click", function () {
    //     $('.item_faqs').removeClass("active");
    //     $(this).parent(".item_faqs").toggleClass("active");
    // })

    $(".faq_wrapper_content .item_faqs h3").click(function () {
        $(this).toggleClass("active").next(".content").slideToggle().parent().siblings().find(".content").slideUp().prev().removeClass("active");
    });


    $('.size-info a').bind('click', function (event) {
        var $anchor = $(this);
        $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top - 130
        }, 1000);
        event.preventDefault();
    });


    // Show more/ show less
    $('.show-more').on("click", function (e) {
        e.preventDefault();
        $(this).parents().addClass("show-full")
    })

    $('.show-less').on("click", function (e) {
        e.preventDefault();
        $(this).parents().removeClass("show-full")
    })

    // Pre-order
    setInterval(function () {
        $('.preorder-description').parents('.button_add_to_cart').addClass("pre-order")
        // Show status OOS product pre-order
        $('.preorder-now-active').parents(".product__info-wrapper").addClass("show-oos");
    }, 1000);

});


// Gallery PDP video            
$(document).ready(function () {
    $('.video-play-icon').on("click", function () {
        var video = jQuery(".product__media-item video");
        video[0].load();
        video[0].play();
        video.trigger('play');
    })

});

//=================================
// PDP Flash popup video Gallery
//=================================
$('[data-fancybox="mixed"]').fancybox({
    buttons: [
        'slideShow',
        'close',
        'zoom'
    ],
    slideShow: {
        autoStart: false
    },
    thumbs: {
        autoStart: true,
        // axis: 'x'
    },

    // Handle icon thumbs video
    onThumbsShow: function (instance) {
        var $thumbs = instance.Thumbs.$list.children();

        $.each(instance.group, function (index, item) {
            if (item.contentType === 'image') {
                $thumbs.eq(index).addClass('thumb-image');
            } else if (item.contentType === 'video') {
                $thumbs.eq(index).addClass('thumb-video');
            }
        });
    }
});

// Slick slider product media
if ($(window).width() < 1000) {
    $('.product__media-list').slick({
        dots: true,
        speed: 1000,
        infinite: true,
        prevArrow: false,
        nextArrow: false,
        autoplay: false,
       customPaging: function(slick,index) {
            var targetImage = slick.$slides.eq(index).find('video source').attr('src');
            if(targetImage != null){
                return '<div class="has-video-icon"></div>';
            }else {
                return '<div class=custom-slick-icon"></div>';
            }

        }
        // autoplaySpeed: 3000
    });
}



// PDP
$(document).ready(function () {
    $(".oct-calculator-open").prop("onclick", null);

    $('fieldset.js.product-form__input.size').parents('.product__info-wrapper').addClass("has-size");

    // Handle color variant link
    let text_color = jQuery('.product-related-swatch__link--active span').text()
    $('.product__color_swatch h3 span').append(text_color)

    // Check pdp has video
    $('.product__media-wrapper .has-video').parents('.slider-mobile-gutter').addClass("product-has-video");

})



// My account
$('.button-address').on("click", function () {
    $(this).parents(".content_left_addess").toggleClass("show-address");
})

$('.list-edit-address button[data-target]').click(function (e) {
    var el = $(this),
        target = el.data('target'),
        indi = el.data('indi'),
        indiTarget = $('[data-id="' + indi + '"]');
    $(target).add(indiTarget).addClass('active').siblings().removeClass('active');

    $(this).parents('.left-content').siblings('.right_content').addClass("hidden-address")

});

// My edit adddress form
if ($(window).width() < 768) {
    $('.list-edit-address button[data-indi]').click(function (e) {
        $('html, body').animate({
            scrollTop: $(".list-edit-form").offset().top
        }, 1000);
    });
}

$('.cancel-address').on("click", function () {
    $(this).parents(".right_content").removeClass("hidden-address");
})


$(".add_new_address").on("click", function () {
    $(this).parents(".left-content").siblings(".right_content").toggleClass("show-address");
})

// Validate add new address
$(".customer.addresses .add-new-address").click(function (e) {
    if ($("#AddressFirstNameNew").val()) {
        $('#Fristname-error').html("")
    } else {
        e.preventDefault();
        $('#Fristname-error').html("Required")
    }

    if ($("#AddressLastNameNew").val()) {
        $('#Lastname-error').html("")
    } else {
        e.preventDefault();
        $('#Lastname-error').html("Required")
    }

    if ($("#AddressAddress1New").val()) {
        $('#Address-error').html("")
    } else {
        e.preventDefault();
        $('#Address-error').html("Required")
    }

    if ($("#AddressZipNew").val()) {
        $('#Postal-error').html("")
    } else {
        e.preventDefault();
        $('#Postal-error').html("Required")
    }
});


// Show hide password
$(".toggle-password").click(function() {
    $(this).toggleClass("show");
    input = $('#RegisterForm-password');
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

$(".toggle-password-login").click(function() {
    $(this).toggleClass("show");
    input = $('#CustomerPassword');
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

// Blog
if ($('.list-category-blog ul').length) {
    var locator_url = window.location.href;
    // console.log(url)
    $(".list-category-blog ul > li > a").each(function() {
        var urla = $(this).attr("href");
        if (locator_url == urla) {
            $(this).parent("li").addClass("active-link");
        }
    });
}

// Figure blog detail
$(document).ready(function () {
    $(".article-template__content img").each(function (index) {
        var alt = $(this).attr('alt');
        if (alt != "") {
            $(this).wrap("<figure />");
            $(this).parent().append("<figcaption class='figcap'>" + alt + "</figcaption>");
        }
    });
});

// Newletter
$('.submit-success').parents('.footer-block__newsletter').addClass("submit-newsletter")


// Validate form login/register
$(document).ready(function () {
    $("#create_customer button").click(function (e) {
        if ($("#RegisterForm-FirstName").val()) {
            $('#RegisterForm-firstname-error').html("")
        } else {
            e.preventDefault();
            $('#RegisterForm-firstname-error').html("First name can't blank.")
        }

        if ($("#RegisterForm-LastName").val()) {
            $('#RegisterForm-lastname-error').html("")
        } else {
            e.preventDefault();
            $('#RegisterForm-lastname-error').html("Last name can't blank.")
        }

        if ($("#RegisterForm-email-custom").val()) {
            $('#RegisterForm-email-error-custom').html("")
        } else {
            e.preventDefault();
            $('#RegisterForm-email-error-custom').html("Email address can't blank.")
        }

        if ($("#RegisterForm-password").val()) {
            $('#RegisterForm-password-error').html("")
        } else {
            e.preventDefault();
            $('#RegisterForm-password-error').html("Password can't blank.")
        }

    });

    // Reset form
    $(".reset-password-form button").click(function (e) {
        if ($("#RecoverEmail").val()) {
            $('#RegisterForm-email-error').html("")
        } else {
            e.preventDefault();
            $('#RegisterForm-email-error').html("Email can't blank.")
        }
    })

});


// Validate form contact us
$(document).ready(function () {
    $(".contact__button button").click(function (e) {
        if ($("#ContactForm-name").val()) {
            $('#Contactname-error').html("")
        } else {
            e.preventDefault();
            $('#Contactname-error').html("Required")
        }

        if ($("#ContactForm-email").val()) {
            $('#ContactEmail-error').html("")
        } else {
            e.preventDefault();
            $('#ContactEmail-error').html("Required")
        }

        if ($("#ContactForm-phone").val()) {
            $('#Contact-phone-error').html("")
        } else {
            e.preventDefault();
            $('#Contact-phone-error').html("Required")
        }

        if ($("#ContactForm-body").val()) {
            $('#Contact-comment-error').html("")
        } else {
            e.preventDefault();
            $('#Contact-comment-error').html("Required")
        }

    });

});


// Picky app custom class
setInterval(function(){
    $('.picky-widget').parents(".product__info-wrapper").addClass("has-bundles")
}, 1000)

// Filter custom listing
$(".filter-item .product-single__accordion__title").on("click",function(e){
    e.preventDefault();
    $(this).parents(".filter-item").toggleClass("active");
})

// remove class when click outside
$(document).on('click', function (event) {
    if (!$(event.target).closest('.filter-item').length) {
        $(".filter-item").removeClass("active");
    }
})

$(".filter-item .product-single__accordion__title").parents(".section-wrapper-collection").addClass("filter-custom");


// Menu mobile custom
$(".menu-drawer__menu-item").on("click",function(){
    $(this).parents(".menu-drawer-item-details").toggleClass("active");
});


// Section reviews
$('.js-reviews-customer-carousel').slick({
	infinite: true,
	slidesToShow: 4,
	slidesToScroll: 4,
	arrows: true,
	dots: false,

	responsive: [{
			breakpoint: 1600,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: false
			}
		},
		{
			breakpoint: 1025,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				infinite: true,
				dots: false
			}
		},

		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false
			}
		}
	]
});

// Handle click slide
$('.reviews-customer__wrapper .arrow-right .button-arrow-left').on("click",function(){
    $(this).parents(".reviews-customer__wrapper").find(".slick-prev").trigger("click");
})

$('.reviews-customer__wrapper .arrow-right .button-arrow-right').on("click",function(){
    $(this).parents(".reviews-customer__wrapper").find(".slick-next").trigger("click");
})

//Section slide show blog
$('.main-blog-custom.slideshow').slick({
	infinite: true,
	slidesToShow: 2,
	slidesToScroll: 2,
	arrows: true,
	dots: false,

	responsive: [
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
	            arrows: false,
			}
		}
	]
});



// // Blog article product recommend
//   $('.related-products-wrapper .related-product-list').not('.slick-initialized').slick({
//     infinite: true,
//     slidesToShow: 3.5,
//     slidesToScroll: 1,
//     dots: false,
//     arrows: true,
//     responsive: [
//         {
//         breakpoint: 1099,
//         settings: {
//             slidesToShow: 3
//             }
//         },
//         {

//             breakpoint: 575,
//             settings: {
//                 slidesToShow: 1.2
//             }
//         }
//     ]
// });

// // Apply blog has only 3 item
// if ($(window).width() < 600) { 
//     $('.related-products-wrapper .product_related__grid').not('.slick-initialized').slick({
//         infinite: true,
//         slidesToShow: 1.2,
//         slidesToScroll: 1,
//         dots: false,
//         arrows: true,
//     });

// }

$(".feature_product__arrows .arrow-prev").on("click",function(){
    $("body").find(".slick-prev").trigger("click");
})

$(".feature_product__arrows .arrow-next").on("click",function(){
    $("body").find(".slick-next").trigger("click");
})


var select = $('.select_value.size select');
var selected = $('.select_value .label_variant');

select.on('change', function(){
    var selectedOptionText = $(this).find('option:selected').text();
    
    selected.text(selectedOptionText);
});
